import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../Context/AuthContext";
import Preloader from "../../shared/PreLoaders";
import TableComponent from "../../utils/TableComponent";
import { Authorization } from "../../Context/Authorization";
const inputStyle = {
  width: "100%", padding: "9px 12px", border: "1.5px solid #E2E8F0",
  borderRadius: 8, fontSize: 13, color: "#1A202C", background: "#fff",
  outline: "none", transition: "border-color 0.2s", cursor: "pointer",
};
const labelStyle = { fontSize: 12, fontWeight: 600, color: "#2D3748", marginBottom: 6, display: "flex", alignItems: "center", gap: 5 };

const Manage = () => {
  const [vfcData, setVfcData] = useState([]);
  const navigate = useNavigate();
  const { permissions } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const Api = process.env.REACT_APP_API;
  const [circle, setCircle] = useState([]);
  const [division, setDivision] = useState([]);
  const [selectedCircle, setSelectedCircle] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedRange, setSelectedRange] = useState("");
  const [showCircle, setShowCircle] = useState(false);
  const [showDivision, setShowDivision] = useState(false);
  const [jfmcTypes, setJfmcTypes] = useState([]);
  const [selectedJfmcType, setSelectedJfmcType] = useState("");
  const [showJfmcType, setShowJfmcType] = useState(false);
  /* ── Auto-fetch when JFMC type changes ── */
  useEffect(() => {
    if (selectedJfmcType) {
      handleFilter();
    } else {
      setVfcData([]);
    }
  }, [selectedJfmcType, selectedCircle, selectedDivision, selectedRange,]);

  useEffect(() => {
    const fetchMasterData = async () => {
      setLoading(true);
      try {
        const config = Authorization();
        const [circleRes, divisionRes, jfmcRes] = await Promise.all([
          axios.get(`${Api}/api/circles`, config),
          axios.get(`${Api}/api/divisions`, config),
          axios.get(`${Api}/api/jfmc-Types`, config),
        ]);

        setCircle(circleRes.data || []);
        setDivision(divisionRes.data || []);
        setJfmcTypes(jfmcRes.data || []);
      } catch (err) {
        console.error("Error loading master data", err);
      }
      setLoading(false);
    };
    fetchMasterData();
  }, [Api]);

  // const fetchVfcByJfmcType = async (jfmcTypeId) => {
  //   setLoading(true);
  //   try {
  //     const Config = Authorization();
  //     const response = await axios.post(`${Api}/api/vfcs/jfmc`, { jfmcTypeId }, Config);
  //     setVfcData(response.data.vfcs || []);
  //   } catch (error) {
  //     console.error("Error fetching VFC data", error);
  //     toast.error("Failed to load VFCs");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleFilter = async () => {
    try {
      setLoading(true);

      const Config = Authorization();

      const response = await axios.post(
        `${Api}/api/vfcs/filter`,
        {
          jfmcTypeId: selectedJfmcType || null,
          circleId: selectedCircle || null,
          divisionId: selectedDivision || null,
          rangeId: selectedRange || null,
        },
        Config
      );

      setVfcData(response.data.vfcs || []);
    } catch (error) {
      console.error(error);
      toast.error("Failed to filter VFCs");
    } finally {
      setLoading(false);
    }
  };
  const handleDeleteVfc = async (id) => {
    if (!window.confirm("Are you sure you want to delete this JFMC?")) return;
    try {
      const Config = Authorization();
      await axios.delete(`${Api}/api/vfcs/${id}`, Config);
      setVfcData(vfcData.filter((v) => v._id !== id));
      toast.success("Deleted Successfully");
    } catch (err) {
      console.error("Error deleting VFC", err);
      toast.error("Failed to delete VFC");
    }
  };

  const handleEditVfc = (id) => navigate(`edit/${id}`);
  const handleAddVfc = () => navigate("vfc/add");
  const TogglePill = ({ label, icon, checked, onChange }) => (
    <label style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "7px 14px", borderRadius: 20, border: `1.5px solid ${checked ? "#2E7D32" : "#E2E8F0"}`, background: checked ? "#E8F5E9" : "#fff", color: checked ? "#1B5E20" : "#718096", fontSize: 12, fontWeight: 600, cursor: "pointer", transition: "all 0.2s", userSelect: "none" }}>
      <input type="checkbox" checked={checked} onChange={onChange} style={{ display: "none" }} />
      <i className={`mdi ${icon}`} style={{ fontSize: 14 }} />
      {label}
    </label>
  );
  const columns = [
    {
      headerName: "Action", field: "action", pinned: "left", width: 90,
      cellRenderer: (params) => (
        <div style={{ display: "flex", gap: 8, alignItems: "center", paddingTop: 4 }}>
          {permissions.includes("EditVfc") && (
            <i className="mdi mdi-pencil" title="Edit"
              style={{ fontSize: "1.2rem", cursor: "pointer", color: "#1565C0" }}
              onClick={() => handleEditVfc(params.data._id)} />
          )}
          {permissions.includes("DeleteVfc") && (
            <i className="mdi mdi-delete" title="Delete"
              style={{ fontSize: "1.2rem", cursor: "pointer", color: "#C62828" }}
              onClick={() => handleDeleteVfc(params.data._id)} />
          )}
        </div>
      ),
    },
    {
      headerName: "SI.No",
      field: "index",
      valueGetter: (params) => {
        return params.node ? params.node.rowIndex + 1 : "";
      }
    },
    {
      headerName: "JFMC Name",
      field: "vfcName",
      cellRenderer: (params) => (
        <span
          style={{
            color: "#1565C0",
            cursor: "pointer",
            fontWeight: 600,
            textDecoration: "underline",
          }}
          onClick={() =>
            navigate(`/vfc/manage/view/${params.data._id}`, {
              state: { vfc: params.data },
            })
          }
        >
          {params.value}
        </span>
      ),
    },
    { headerName: "Range", field: "rangeId.rangeName" },
    {
      headerName: "Circle",
      field: "rangeId.divisionId.circleId.circleName",
    },

    {
      headerName: "Division",
      field: "rangeId.divisionId.divisionName",
    },

    {
      headerName: "Latest Bank Balance",
      field: "latestBankBalance",
      valueFormatter: (p) => {
        if (!p.value) return "—";

        const amount =
          typeof p.value === "object" && p.value.$numberDecimal
            ? parseFloat(p.value.$numberDecimal)
            : Number(p.value);

        return amount.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      },
    },

    // {
    //   headerName: "Latest Cash Balance",
    //   field: "latestCashBalance",
    //   valueFormatter: (p) => {
    //     if (!p.value) return "—";

    //     const amount =
    //       typeof p.value === "object" && p.value.$numberDecimal
    //         ? parseFloat(p.value.$numberDecimal)
    //         : Number(p.value);

    //     return amount.toLocaleString("en-IN", {
    //       minimumFractionDigits: 2,
    //       maximumFractionDigits: 2,
    //     });
    //   },
    // },

    {
      headerName: "Balance Date",
      field: "latestBalanceDate",
      valueFormatter: (p) =>
        p.value
          ? new Date(p.value).toLocaleDateString("en-IN")
          : "—",
    },
    {
      headerName: "Beat Name", field: "beatName", hideByDefault: true,
    },
    { headerName: "Beat Code", field: "beatCode", hideByDefault: true, },
    { headerName: "BDO Office Name", field: "bdoOfficeName", hideByDefault: true, },
    { headerName: "BDO Office Code", field: "bdoOfficeCode", hideByDefault: true, },
    { headerName: "LGD Code", field: "lgdCode", hideByDefault: true, },
    { headerName: "Location", field: "location", hideByDefault: true, },
    { headerName: "Address", field: "address", hideByDefault: true, },
    { headerName: "Village", field: "villageName", hideByDefault: true, },
    { headerName: "Village Code", field: "villageCode", hideByDefault: true, },
    { headerName: "Panchayath", field: "panchayath", hideByDefault: true, },
    { headerName: "Thaluk", field: "thaluk", hideByDefault: true, },
    { headerName: "Thaluk Code", field: "thalukCode", hideByDefault: true, },
    { headerName: "Pin Code", field: "pinCode", hideByDefault: true, },
    { headerName: "Date of Establishment", field: "dateOfEstablishment", valueFormatter: (p) => p.value ? new Date(p.value).toLocaleDateString("en-IN") : "—", hideByDefault: true, },
    { headerName: "Bank Name", field: "bankName", hideByDefault: true, },
    { headerName: "Branch", field: "branch", hideByDefault: true, },
    { headerName: "A/c No", field: "accountNumber", hideByDefault: true, },
    { headerName: "IFSC Code", field: "ifscCode", hideByDefault: true, },
    { headerName: "Registration No", field: "registrationNo", hideByDefault: true, },
    { headerName: "Registration Date", field: "registrationDate", valueFormatter: (p) => p.value ? new Date(p.value).toLocaleDateString("en-IN") : "—", hideByDefault: true, },
    { headerName: "Total Family", field: "totalFamily", hideByDefault: true, },
    { headerName: "Total Population", field: "totalPopulation", hideByDefault: true, },
    { headerName: "VFC Family", field: "vfcFamily", hideByDefault: true, },
  ];

  /* ════════════════════════════════════════════
     RENDER
  ════════════════════════════════════════════ */
  return (
    <div>
      {loading && <Preloader loading={loading} />}

      {/* ── Page Header ── */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
        <div>
          <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>Manage JFMC</h4>
          <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
            <span style={{ color: "#A0AEC0" }}>JFMC</span>
            <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
            <span style={{ color: "#2E7D32", fontWeight: 600 }}>All JFMC</span>
          </div>
        </div>
        {permissions.includes("AddVfc") && (
          <button
            onClick={handleAddVfc}
            style={{ padding: "9px 20px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: 7, boxShadow: "0 2px 8px rgba(46,125,50,0.3)" }}
          >
            <i className="mdi mdi-plus" style={{ fontSize: 16 }} />
            Add JFMC
          </button>
        )}
      </div>

      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", padding: "20px 24px", marginBottom: 20 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
          <span style={{ width: 30, height: 30, background: "linear-gradient(135deg,#1B5E20,#43A047)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 14 }}>
            <i className="mdi mdi-filter-variant" />
          </span>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#1A202C" }}>Filter Report</span>
          <span style={{ fontSize: 11, color: "#A0AEC0", marginLeft: 4 }}>Toggle filters and select a date to view records</span>
        </div>

        {/* Toggle pills */}
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 16 }}>
          <TogglePill label="Circle" icon="mdi-circle-outline" checked={showCircle} onChange={(e) => { setShowCircle(e.target.checked); if (!e.target.checked) setSelectedCircle(""); }} />
          <TogglePill label="Division" icon="mdi-domain" checked={showDivision} onChange={(e) => { setShowDivision(e.target.checked); if (!e.target.checked) setSelectedDivision(""); }} />
          <TogglePill
            label="JFMC Type"
            icon="mdi-shape-outline"
            checked={showJfmcType}
            onChange={(e) => {
              setShowJfmcType(e.target.checked);

              if (!e.target.checked) {
                setSelectedJfmcType("");
              }
            }}
          />        </div>

        {/* Conditional selects */}
        {(showCircle || showDivision || showJfmcType) && (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0,1fr))", gap: 12, marginBottom: 16 }}>
            {showCircle && (
              <div>
                <label style={labelStyle}><i className="mdi mdi-circle-outline" style={{ color: "#43A047" }} /> Circle</label>
                <select value={selectedCircle} onChange={(e) => setSelectedCircle(e.target.value)} style={inputStyle} onFocus={(e) => e.target.style.borderColor = "#4CAF50"} onBlur={(e) => e.target.style.borderColor = "#E2E8F0"}>
                  <option value="">— Select —</option>
                  {circle.sort((a, b) => a.circleName.localeCompare(b.circleName)).map((c) => <option key={c._id} value={c._id}>{c.circleName}</option>)}
                </select>
              </div>
            )}
            {showDivision && (
              <div>
                <label style={labelStyle}><i className="mdi mdi-domain" style={{ color: "#43A047" }} /> Division</label>
                <select value={selectedDivision} onChange={(e) => setSelectedDivision(e.target.value)} style={inputStyle} onFocus={(e) => e.target.style.borderColor = "#4CAF50"} onBlur={(e) => e.target.style.borderColor = "#E2E8F0"}>
                  <option value="">— Select —</option>
                  {division.sort((a, b) => a.divisionName.localeCompare(b.divisionName)).map((d) => <option key={d._id} value={d._id}>{d.divisionName}</option>)}
                </select>
              </div>
            )}
            {showJfmcType && (
              <div>
                <label style={labelStyle}>
                  <i
                    className="mdi mdi-shape-outline"
                    style={{ color: "#43A047" }}
                  />
                  JFMC Type
                </label>

                <select
                  value={selectedJfmcType}
                  onChange={(e) =>
                    setSelectedJfmcType(e.target.value)
                  }
                  style={inputStyle}
                  onFocus={(e) =>
                    (e.target.style.borderColor = "#4CAF50")
                  }
                  onBlur={(e) =>
                    (e.target.style.borderColor = "#E2E8F0")
                  }
                >
                  <option value="">— Select —</option>

                  {jfmcTypes.sort((a, b) => a.jfmcTypeName.localeCompare(b.jfmcTypeName)).map((j) => (
                    <option key={j._id} value={j._id}>
                      {j.jfmcTypeName}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
        )}</div>
      {/* ── No JFMC type selected ── */}
      {!selectedJfmcType ? (
        <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #FED7D7", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", padding: "48px 24px", textAlign: "center" }}>
          <div style={{ width: 60, height: 60, background: "#FFF5F5", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px" }}>
            <i className="mdi mdi-tag-outline" style={{ fontSize: 28, color: "#E53E3E" }} />
          </div>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#2D3748", marginBottom: 6 }}>JFMC Type not selected</div>
          <div style={{ fontSize: 12, color: "#A0AEC0" }}>Use the <strong>JFMC Type</strong> selector in the top navigation bar to choose a type</div>
        </div>
      ) : (
        <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>

          {/* Card header */}
          <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", borderBottom: "1px solid #EDF2F7", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
            <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
              <i className="mdi mdi-home-group" />
            </span>
            <span style={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>{selectedJfmcType.jfmcTypeName} — JFMC Records</span>
            <span style={{ marginLeft: "auto", background: "rgba(255,255,255,0.2)", color: "#fff", fontSize: 11, fontWeight: 700, padding: "2px 10px", borderRadius: 50 }}>
              {vfcData.length} records
            </span>
          </div>

          {/* Table */}
          <div style={{ padding: "16px 20px" }}>
            <TableComponent data={vfcData} columns={columns} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Manage;
